import {Link, CustomComponent} from '../../common/components';
import {AuthedUrlWrapper} from '../../common/components/AuthedUrlWrapper';
import {FlagIcon} from '../../common/components/FlagIcon';
import {escapeQuotesOnServer} from '../../common/util';
import {ProfileImage} from './ProfileImage';
import {OfficialBadge} from './OfficialBadge';
import {subscribe} from '../../../replete';

import './ProfilePageHeader.scss';

function ProfileCTA({profile}: {profile: api.User}) {
    const hasCta = profile.partnercta?.text && profile.partnercta?.url;
    if (hasCta) {
        return (
            <Link external={true} to={profile.partnercta.url}>
                <div className="white-button cta-button">
                    {profile.partnercta.text}
                </div>
            </Link>
        );
    }
}

function ProfileLinks({profile}: {profile: api.User}) {
    if (profile.partnerlinks) {
        return <span className="links">{profile.partnerlinks.map((link) => {
            const imageAssets = [
                'earth', 'facebook', 'instagram', 'twitter', 'youtube'];
            const icon = link.icon && imageAssets.includes(link.icon) ?
                link.icon : 'link';
            return <Link key={link.url} to={link.url || '/'} external={true}>
                <div
                    className="social-icon"
                    style={{
                        'background-image': escapeQuotesOnServer(`url("/assets/img/icons/brandedPartner/${icon}.svg")`),
                    }}
                >
                    {link.tooltip && <span className="tooltip">
                        <span>{link.tooltip}</span>
                    </span>}
                </div>
            </Link>;
        })}</span>;
    }
}

function BannerImage({profile}: {profile: api.User}) {
    return <AuthedUrlWrapper url={profile.partnerbanner?.['1110']} childrenFunc={(url) => {
        const backgroundStyle: app.Style = {};
        if (url) {
            backgroundStyle['background-image'] = escapeQuotesOnServer(`url("${url}")`);
        } else {
            backgroundStyle['background-image'] = ProfileImage.getBackgroundGradient(profile);
        }
        return <div className="banner-image" style={backgroundStyle}/>;
    }}/>;
}

function NameInfo({profile}: {profile: api.User}) {
    const username = profile.partnername || profile.username;
    return (
        <div className="name-info">
            <h1 className="partnername">
                {username}
                <OfficialBadge flags={profile.flags} tooltip={true}/>
            </h1>
            <div className="tagline">{profile.tagline}</div>
        </div>
    );
}

function LinkActions({profile}: {profile: api.User}) {
    const showFlagIcon = profile.partnerbanner?.['1110'] || profile.avatars?.['256'];
    return <div className="link-actions">
        <ProfileLinks profile={profile}/>
        <ProfileCTA profile={profile}/>
        { showFlagIcon && <FlagIcon/> }
    </div>;
}

@subscribe({
    isMobile: ['ui.isMobile'],
})
export class ProfilePageHeader extends CustomComponent {
    render() {
        const {profile} = this.props;

        if (this.props.isMobile) {
            return (
                <div className="MobileProfilePageHeader">
                    <Link to={this.linkToProfile(profile)}>
                        <BannerImage profile={profile} />
                    </Link>
                    <div className="profile-details container">
                        <ProfileImage user={profile} />
                        <LinkActions profile={profile}/>
                        <NameInfo profile={profile} />
                    </div>
                </div>
            );
        }
        return (
            <div className="ProfilePageHeader">
                <Link to={this.linkToProfile(profile)}>
                    <BannerImage profile={profile} />
                </Link>
                <div className="profile-details">
                    <div className="container">
                        <ProfileImage user={profile} />
                        <NameInfo profile={profile} />
                        <LinkActions profile={profile}/>
                    </div>
                </div>
            </div>
        );
    }
}
